export class LocalPreferences {
    private static readonly STORAGE_KEY = 'preferences';

    public has(key: string): boolean {
        const preferences = this.getAll();
        return Object.prototype.hasOwnProperty.call(preferences, key);
    }

    public get(key: string): any {
        const preferences = this.getAll();
        return preferences[key];
    }

    public set(key: string, value: any): void {
        const preferences = this.getAll();
        preferences[key] = value;
        localStorage.setItem(LocalPreferences.STORAGE_KEY, JSON.stringify(preferences));
    }

    public getAll(): Record<string, any> {
        const preferences = localStorage.getItem(LocalPreferences.STORAGE_KEY);
        return preferences ? JSON.parse(preferences) : {};
    }
}
